module.exports = __webpack_public_path__ + "static/heavy_ugl4-967eb933e5ff29ffffcb7ace9bb72e7f.jpg";